import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IAnnotationReviewService } from '../../../annotationReview.service';
import { IImage, NoImageReason } from '../../../annotations.interface';
import { IAnnotationsStore } from '../../../annotations.store';
import { IAnnotationUiStore } from '../../../annotationUi.store';
import { IReviewImagesQueueService } from '../../../reviewImagesQueue.service';
import { IAnnotationReviewStore } from '../annotationReview.store';
import { ReviewMode } from '../models/reviewMode';

interface IReviewRenderProps {
  noImage: boolean;
  noImageReason: NoImageReason;
  mode: ReviewMode;
  image?: IImage;
  handleRefresh: () => Promise<void>;
}

interface IProps {
  children(props: IReviewRenderProps): ReactElement;
}

export const ReviewContainer = observer((props: IProps): ReactElement => {
  const annotationUiStore = useInjection(IAnnotationUiStore.$);
  const annotationReviewService = useInjection(IAnnotationReviewService.$);
  const imagesQueueService = useInjection(IReviewImagesQueueService.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const reviewStore = useInjection(IAnnotationReviewStore.$);

  const { projectId } = useParams<{ projectId: string }>();

  const noImage = !annotationsStore.image && !annotationUiStore.isImageLoading && !imagesQueueService.isAnyRequestInProgress;

  useEffect(() => {
    void annotationReviewService.reviewStartedAsync(projectId, imagesQueueService);

    return (): void => {
      void annotationReviewService.reviewFinishedAsync();
    };
  }, [projectId]);

  const handleRefresh = async (): Promise<void> => {
    annotationReviewService.refreshRequested();
    return Promise.resolve();
  };

  return props.children({
    noImage,
    noImageReason: annotationsStore.noImageReason,
    image: annotationsStore.image,
    handleRefresh,
    mode: reviewStore.currentMode,
  });
});
